/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Dropdown, DropdownToggle, DropdownMenu,
} from 'reactstrap';

// Import images
import { withTranslation } from 'react-i18next';

import { get } from '../../../helpers/api_helper';

const zebraRowStyle = {
  minHeight: '30px',
  cursor: 'pointer',
};

const printerNameWrapStyle = {
  marginTop: '7px',
  maxWidth: '80%',
};

const printerNameStyle = {
  color: '#484848',
  display: 'flex',
  fontSize: '17px',
  minWidth: 0,
};

const printerNameStartStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const printerNameEndStyle = {
  flexShrink: 0,
  maxWidth: '50%',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
};

const getPrinterNameParts = (name) => {
  const printerName = name.toUpperCase();
  const splitIndex = Math.ceil(printerName.length / 2);

  return {
    start: printerName.slice(0, splitIndex).trim(),
    end: printerName.slice(splitIndex).trim(),
  };
};

function ZebraDropdown(props) {
  const { t } = props;

  const [menu, setMenu] = useState(false);
  const [zebras, setZebras] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState(localStorage.getItem('selectedPrinter'));

  // eslint-disable-next-line no-unused-vars
  const user = JSON.parse(localStorage.getItem('authUser'));

  const toggle = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    const fetchData = async () => {
      const result = await get('/api/zebra?per=100&sort=name');

      setZebras(result.results);
    };

    if (menu) fetchData();
  }, [menu]);

  const handleSelectPrinter = (id) => {
    setSelectedPrinter(id.toString());
    localStorage.setItem('selectedPrinter', id.toString());
  };

  return (
    <Dropdown
      isOpen={menu}
      toggle={toggle}
      className="dropdown d-inline-block"
      tag="li"
    >
      <DropdownToggle
        className="btn header-item noti-icon position-relative"
        tag="button"
        id="page-header-notifications-dropdown"
      >
        <i className="mdi mdi-barcode-scan" />
        {selectedPrinter === null && (
          <span className="badge bg-warning rounded-pill text-dark">
            <span className="mdi mdi-close-thick" />
          </span>
        )}
        {selectedPrinter !== null && (
          <span className="badge bg-success rounded-pill">
            <span className="mdi mdi-check" />
          </span>
        )}
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu dropdown-menu-md dropdown-menu-end p-0" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <div>
          {zebras.length === 0 && (
            <div className="p-3 text-center">{t('Loading...')}</div>
          )}
          {zebras.length > 0 && (
            <div>
              {zebras.map((zebra) => {
                const printerNameParts = getPrinterNameParts(zebra.name);

                return (
                  <div
                    key={zebra.id}
                    className="pb-0 pt-2 pe-3 ps-3"
                    style={zebraRowStyle}
                    onClick={() => handleSelectPrinter(zebra.id)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        handleSelectPrinter(zebra.id);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    <div className="float-end" style={printerNameWrapStyle}>
                      <span style={printerNameStyle} title={zebra.name.toUpperCase()}>
                        <span style={printerNameStartStyle}>
                          {printerNameParts.start}
                        </span>
                        <span style={printerNameEndStyle}>
                          {printerNameParts.end}
                        </span>
                      </span>
                    </div>
                    {selectedPrinter === zebra.id.toString() && (
                      <li className="position-relative">
                        <span className="mdi mdi-printer-pos" style={{ fontSize: '25px' }} />
                        <span className="badge bg-success rounded-pill position-absolute text-dark" style={{ top: '2px', left: '17px' }}>
                          <span className="mdi mdi-check" />
                        </span>
                      </li>
                    )}
                    {selectedPrinter !== zebra.id.toString() && (
                      <li>
                        <span className="mdi mdi-printer-pos" style={{ fontSize: '25px' }} />
                      </li>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </DropdownMenu>
    </Dropdown>
  );
}

ZebraDropdown.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(ZebraDropdown);
